import { Context } from "csi/def/Context";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "lodash";
import OwnershipTypeRenderer from "src/Apparel/OwnershipTypeRenderer";

const StyleBOMOwnershipTypeRenderer = declare(OwnershipTypeRenderer, {
	/**
     * @override
     */
	canToggle(ctx: Context): boolean {
		return false;
	},

	/**
     * @override
     * Display "Linked" if the Style BOM is linked to a LinkedHostDataSheet
     */
	getOwnershipType(ctx: Context): string {
		return this.OWNERSHIP_TYPE_LINKED;
	},

	/**
     * @override
     */
	shouldDisplayToggle(ctx: Context): boolean {
		return false;
	},
});

export = StyleBOMOwnershipTypeRenderer;
